export default "__VITE_ASSET__BtXloCsU__"